
export default function Footer() {
  return (
    <footer className="py-20 px-6 bg-white border-t border-neutral-200">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-16">
          <div>
            <h3 className="text-2xl mb-6 font-light tracking-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Studio Sang
            </h3>
            <p className="text-neutral-600 font-light leading-relaxed">
              Premium portrait photography studio dedicated to capturing timeless moments with artistic excellence.
            </p>
          </div>

          <div>
            <h4 className="text-sm tracking-[0.2em] uppercase mb-6 font-medium text-neutral-900">
              Contact
            </h4>
            <div className="space-y-3">
              <a href="tel:+82-2-1234-5678" className="flex items-center gap-3 text-neutral-600 hover:text-neutral-900 transition-colors duration-300 cursor-pointer">
                <i className="ri-phone-line"></i>
                <span className="font-light">+82 2 318 3345</span>
              </a>
              <a href="mailto:hello@studiosang.com" className="flex items-center gap-3 text-neutral-600 hover:text-neutral-900 transition-colors duration-300 cursor-pointer">
                <i className="ri-mail-line"></i>
                <span className="font-light">contact@studiosang.com</span>
              </a>
              <div className="flex items-start gap-3 text-neutral-600">
                <i className="ri-map-pin-line mt-1"></i>
                <span className="font-light">서울 중구 을지로30 롯데호텔 서울 2층</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-sm tracking-[0.2em] uppercase mb-6 font-medium text-neutral-900">
              Follow Us
            </h4>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/studiosang.official/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-12 h-12 border border-neutral-300 hover:border-neutral-900 hover:bg-neutral-900 transition-all duration-300 group cursor-pointer">
                <i className="ri-instagram-line text-xl text-neutral-600 group-hover:text-white transition-colors duration-300"></i>
              </a>
              <a href="https://pf.kakao.com/_yxexmxhn" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-12 h-12 border border-neutral-300 hover:border-neutral-900 hover:bg-neutral-900 transition-all duration-300 group cursor-pointer">
                <i className="ri-kakao-talk-fill text-xl text-neutral-600 group-hover:text-white transition-colors duration-300"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-neutral-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-neutral-500 font-light">
            © 2025 Studio Sang. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors duration-300 font-light cursor-pointer whitespace-nowrap"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
